export default {
  customers: {
    title: 'Customers',
    routes: [
      { label: 'Customers', route: '/customers', icon: 'FaHome' },
      { label: 'Groups', route: '/customers/groups', icon: 'FaBuffer' },
    ],
  },
  organisation: {
    title: 'Organisation',
    routes: [
      { label: 'Details', route: '/organisation/details', icon: 'FaAlignJustify' },
      { label: 'Charge Authentication', route: '/organisation/charge-authentication', icon: 'FaRegCreditCard' },
      { label: 'Team Members', route: '/organisation/team-members', icon: 'FaRegUser' },
    ],
  },
  sessions: {
    title: 'Charging Sessions',
    routes: [
      { label: 'Active & Upcoming', route: '/sessions/active-upcoming-sessions', icon: 'FaRegClock' },
      { label: 'Past', route: '/sessions/past-sessions', icon: 'FaRegCalendarCheck' },
      { label: 'Insights', route: '/sessions/charging-session-insights', icon: 'FaChartPie' },
    ],
  },
  bookings: {
    title: 'Bookings',
    routes: [
      { label: 'Active & Upcoming', route: '/bookings/active-upcoming-bookings', icon: 'FaRegClock' },
      { label: 'Past', route: '/bookings/past-bookings', icon: 'FaRegCalendarCheck' },
      { label: 'Insights', route: '/bookings/bookings-insights', icon: 'FaChartPie' },
    ],
  },
};
